module.exports = __webpack_public_path__ + "media/promo/promo/images/card-1-7f7c94bee1d80f0e3e0ec44d395ab87f.jpg";